import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const CardsDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Cards"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
